export const getTenantSpecificKey = () => '';